<!--
 * @Author: liyunfei12354 3090384495@qq.com
 * @Date: 2025-09-11 15:11:58
 * @LastEditors: liyunfei12354 3090384495@qq.com
 * @LastEditTime: 2025-09-19 16:56:11
 * @FilePath: \vr-exp-h5-frontend\src\components\common\TunDataItem.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <div class="zhu" :class="[{'new': isnew || conhipGirth}, $i18n.locale]">
        <span class="zhu1">{{ title }}</span>
        <img v-if="hipType === 0" src="@/assets/images/fangL.svg" class="tu"/>
        <img v-else-if="hipType === 2" src="@/assets/images/liL.svg" class="tu"/>
        <img v-else-if="hipType === 3" src="@/assets/images/daosanL.svg" class="tu"/>
        <img v-else-if="hipType === 1" src="@/assets/images/yuanL.svg" class="tu"/>
        <img v-else-if="hipType === 4" src="@/assets/images/miL.svg" class="tu"/>
        <p class="zi">{{ hipType === 0 ? $t('fang-xing-tun') : hipType === 2 ? this.$t('li-xing-tun') :
                    hipType === 3 ? this.$t('dao-san-jiao-xing-tun') : hipType === 1 ? this.$t('yuan-xing-tun') : $t('mi-tao-tun')}}</p>
        <img v-if="hipType === 4 || hipType === 1" src="@/assets/images/dianzan.png" class="dianzan" :style="isnew || conhipGirth ? 'left: 48%': 'left: 44%'"/>
        <p v-if="!conhipGirth" class="hip">{{ $t('tun-wei') }}: {{ unit === 'metric' ? toDecimal(hipGirth * 2.54, 1) : toDecimal(hipGirth, 1) }} {{ unit === 'imperial' ? 'in.' : 'cm' }}</p>
        <p v-else-if="conhipGirth" class="hip">{{ $t('ben-ci')}}{{ $t('tun-wei') }}: {{ unit === 'metric' ? toDecimal(hipGirth * 2.54, 1) : toDecimal(hipGirth, 1) }} {{ unit === 'imperial' ? 'in.' : 'cm' }}
            {{ $t('li-shi')}}{{ $t('tun-wei') }}: {{ unit === 'metric' ? toDecimal(conhipGirth * 2.54, 1) : toDecimal(conhipGirth, 1) }} {{ unit === 'imperial' ? 'in.' : 'cm' }}</p>
    </div>
  </div>
</template>

<script>
import { _toDecimal } from '@/assets/js/util.js'
export default {
    props: {
        isnew: Boolean,
        title: String,
        hipType: Number,
        hipGirth: Number,
        conhipGirth: Number
    },
  data () {
    return {
        unit: ''
    }
  },
  mounted() {
        this.unit = window.localStorage.getItem('unit') || 'metric'
  },
   methods: {
    toDecimal(num, digit) {
      return _toDecimal(num, digit);
    },
    }
}
</script>

<style lang="less" scoped>
.zhu{
        background: rgba(255,255,255,0.1);
        border-radius: 4px;
        position: relative;
        width: 140px;
        // display: flex;
        // justify-content: center;
        .tu {
            margin: 20px  27%;
            width: 64px;
        }
        .zi{
            text-align: center;
            // margin: 0px 17px 0px 17px;
            padding-bottom: 10px;
            border-bottom:1px solid #979797;
        }
        .hip {
            font-weight: 400;
            font-size: 12px;
            color: #6F8399;
            line-height: 26px;
            text-align: center;
            font-style: normal;
            margin: 10px;
        }
        .dianzan{
            position: absolute;
            bottom: 44px;
        }
}
.new {
    width: 300px;
    .tu {
        width: 64px;
        margin: 40px 40% 10px 40%;
    }
}
.zhu1 {
    background: linear-gradient( 90deg, rgba(0,145,255,0.4) 0%, rgba(0,145,255,0.6) 100%);
    border-radius: 4px 0px 4px 0px;
    padding: 5px 10px;
    font-size: 11px;
    position: absolute;
    left: 0;
    top: 0;
}
.ar-AR {
    .zhu1 {
        left: auto;
        right: 0;
        border-radius: 0px 4px 0px 4px;
    }
    .zi{
        text-align: center !important;
        margin-right: 0 !important;
    }
    .hip {
        text-align: center !important;
        margin-right: 0 !important;
    }
    
}

/* pl-PL: 历史/当前两张卡片等高，避免因文案长度不同导致高度不一致 */
.zhu.pl-PL:not(.new) {
    display: flex;
    flex-direction: column;
    min-height: 268px;

    .zi {
        min-height: 70px;
        margin: 0 10px;
    }

    .hip {
        margin-top: auto;
    }
}
</style>